import { FC } from 'react';

import { Layout } from 'components/common';

export const Home: FC = () => <Layout>Home page</Layout>;
